
export default {
  props: ['value', 'headers', 'height'],
  data () {
    return { unfoldedGroups: {} }
  },
  computed: {
    fieldHeaders () {
      return this.headers.filter(h => !!h.field)
    },
    groups () {
      return this.fieldHeaders.reduce((groups, header) => {
        if (header.field['x-group'] && !groups.includes(header.field['x-group'])) groups.push(header.field['x-group'])
        return groups
      }, []).concat([''])
    },
    groupStatus () {
      return (group) => {
        let nbSelected = 0
        let nbTotal = 0
        for (const header of this.fieldHeaders) {
          if (header.field['x-group'] !== group) continue
          nbTotal += 1
          if (this.value.includes(header.value)) nbSelected += 1
        }
        if (nbTotal === nbSelected) return 'all'
        if (nbSelected) return 'some'
        return 'none'
      }
    }
  },
  methods: {
    toggleGroup (group, value) {
      if (value) {
        const newValue = [...this.value]
        for (const header of this.fieldHeaders) {
          if (header.field['x-group'] === group && !this.value.includes(header.value)) {
            newValue.push(header.value)
          }
        }
        this.$emit('input', newValue)
      } else {
        const newValue = this.value.filter(v => {
          const header = this.fieldHeaders.find(fh => fh.value === v)
          return header.field['x-group'] !== group
        })
        this.$emit('input', newValue)
      }
    },
    isFirstInGroup (i) {
      const previousGroup = this.fieldHeaders[i - 1] && this.fieldHeaders[i - 1].field && this.fieldHeaders[i - 1].field['x-group']
      return this.fieldHeaders[i].field['x-group'] && this.fieldHeaders[i].field['x-group'] !== previousGroup
    }
  }
}
